import React, { useEffect, useState } from "react";
import { Box, Pagination, Select } from "components";
import { useTranslation } from "react-i18next";
import { Grid } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { localStorageHelper } from "utils";
import { IOption } from "components/select/Select";
import { ConsultationListActionCreators } from "redux/rootActions";
import {
  consultationListDataResponse,
  selectIsLoading,
} from "redux/consultationList/consultationListStates";

import {
  WrapperAction,
  SelectWrapper,
  PaginationWrapper,
  TableStyled,
} from "./ConsultationList.style";
import { generateDynamicRecords } from "utils";

const { useBreakpoint } = Grid;

const ConsultationList = () => {
  const { t }: any = useTranslation("translation", {
    keyPrefix: "layout",
  });
  const { t: t1 }: any = useTranslation("translation", {
    keyPrefix: "user-list",
  });
  const { t: t2 }: any = useTranslation("translation", {
    keyPrefix: "consultation",
  });
  const screens = useBreakpoint();
  const dispatch = useDispatch();
  const currentLanguage = localStorageHelper.getItem("i18nextLng");

  const consultationListData = useSelector(consultationListDataResponse);
  const isLoading = useSelector(selectIsLoading);

  const totalRecord = consultationListData?.total_record || 0;

  const [input, setInput] = useState({
    per_page: 50,
    page: 1,
    locale: currentLanguage || "ja",
  });
  const [recordOptions, setRecordOptions] = useState<IOption[]>([]);
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    dispatch(ConsultationListActionCreators.getConsultationListAction(input));
  }, [input.per_page, input.page]);

  useEffect(() => {
    if (consultationListData && Object.keys(consultationListData).length) {
      let recordOptionsClone: IOption[] = [];
      recordOptionsClone = generateDynamicRecords(
        consultationListData?.total_record,
        t1
      );
      setRecordOptions([...recordOptionsClone]);
      setData(consultationListData.result);
    }
  }, [consultationListData]);

  const handleNormalText2BoldText = (text: string) => {
    const [firstText, secText] = text.split(":");
    return (
      <div>
        <span style={{ fontWeight: "bold" }}>{firstText}：</span>
        {secText}
      </div>
    );
  };

  const columns = [
    {
      title: t2("suspected-illness"),
      dataIndex: "name",
      key: "name",
      width: 140,
    },
    {
      title: t2("answer-content"),
      render: (text: any, record: any) => {
        return (
          <div>
            {record.consult_diagnosis &&
              handleNormalText2BoldText(record.consult_diagnosis)}
            {record.medical_instruct &&
              handleNormalText2BoldText(record.medical_instruct)}
            {record.consult_diagnosis1 &&
              handleNormalText2BoldText(record.consult_diagnosis1)}
            {record.diagnosis_comment &&
              handleNormalText2BoldText(record.diagnosis_comment)}
            {record.medical_instruction_comment &&
              handleNormalText2BoldText(record.medical_instruction_comment)}
            {record.medicine_comment &&
              handleNormalText2BoldText(record.medicine_comment)}
          </div>
        );
      },
    },
    {
      title: t2("consultation-date"),
      dataIndex: "created_at",
      key: "created_at",
      width: 150,
    },
    {
      title: t2("response-date"),
      dataIndex: "doctor_response",
      key: "doctor_response",
      width: 150,
    },
  ];

  const handleOnChangeSizeChange = (limit: number) => {
    setInput((prevState: any) => ({ ...prevState, per_page: limit, page: 1 }));
  };

  const handleChangePage = (page: number) => {
    setInput((prevState: any) => ({ ...prevState, page }));
  };

  const ShowPagination = () => {
    return totalRecord > input.per_page ? (
      <PaginationWrapper>
        <Pagination
          current={input.page}
          onChange={handleChangePage}
          pageSize={input.per_page}
          total={totalRecord}
          showSizeChanger={false}
          showLessItems={!screens.xl}
        />
      </PaginationWrapper>
    ) : (
      <React.Fragment></React.Fragment>
    );
  };

  return (
    <Box title={t("consultation-label")} padding="24px 16px">
      <WrapperAction>
        <SelectWrapper>
          <div
            style={{
              fontSize: 14,
              fontWeight: 500,
              marginRight: 5,
            }}
          >
            {t1("record")}
          </div>
          <Select
            defaultValue={50}
            options={recordOptions}
            onChange={handleOnChangeSizeChange}
          />
        </SelectWrapper>
        <ShowPagination />
      </WrapperAction>
      <TableStyled
        dataSource={data}
        columns={columns}
        scroll={{ x: "max-content" }}
        loading={isLoading}
        style={{ marginBottom: 30 }}
      />
      <ShowPagination />
    </Box>
  );
};

export default ConsultationList;
